/**
 * @author      esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright   Copyright (c) 2023, Zumper
 * @description Map data and layer helpers
 */

import type { FillLayerSpecification, LineLayerSpecification } from '@vis.gl/react-mapbox'

export const getData = (
  dataJson: GeoJSON.Geometry,
  city: string | undefined,
  neighborhood: string | undefined
): GeoJSON.Feature => {
  return {
    type: 'Feature',
    geometry: dataJson,
    properties: {
      name: city || neighborhood,
    },
  }
}

export const lineLayer: LineLayerSpecification = {
  id: 'lineLayer',
  type: 'line',
  source: 'lineLayer',
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-opacity': 1,
    'line-color': '#109EE5',
    'line-width': 2,
  },
}

export const fillLayer: FillLayerSpecification = {
  id: 'fillLayer',
  type: 'fill',
  source: 'fillLayer',
  paint: {
    'fill-color': '#109EE5',
    'fill-opacity': 0.1,
  },
}
